const t = "image", e = "button", r = {
  "story-teaser": "story-teaser",
  image: t,
  "story-teaser__tag": "story-teaser__tag",
  "story-teaser__media-container": "story-teaser__media-container",
  "video-player": "video-player",
  "story-teaser__details": "story-teaser__details",
  "story-teaser__title": "story-teaser__title",
  "story-teaser__description": "story-teaser__description",
  "story-teaser__date": "story-teaser__date",
  "story-teaser__link": "story-teaser__link",
  "story-teaser--variant-a": "story-teaser--variant-a",
  "story-teaser__description-container": "story-teaser__description-container",
  "story-teaser--variant-b": "story-teaser--variant-b",
  "story-teaser--variant-c": "story-teaser--variant-c",
  button: e,
  "story-teaser--unpublished": "story-teaser--unpublished"
};
export {
  e as button,
  r as default,
  t as image
};
